module.exports = __webpack_public_path__ + "img/suport.b9bc1d65.png";